<template>
  <div class="container">
    <HeaderComponent />
    <main>
      <div class="wpb_wrapper">
        <div class="wpb_text_column wpb_content_element imprensa-assessoria">
          <div class="title">
            <p>{{ translate.alert }}</p>
          </div>
        </div>
        <form @submit.prevent="save">
          <div class="row">
            <div :class="['col-6 form-group pr-3', hasErrorFiled('name')]">
              <input
                type="text"
                class="form-control"
                v-model="model.name"
                :placeholder="`${translate.name}`"
              />
              <div class="invalid-feedback">
                {{ translate.name }} {{ translate.required }}
              </div>
            </div>
            <div :class="['col-6 form-group', hasErrorFiled('email')]">
              <input
                type="email"
                class="form-control"
                v-model="model.email"
                :placeholder="`${translate.email}`"
              />
              <div class="invalid-feedback">
                {{ translate.email }} {{ translate.required }}
              </div>
            </div>
          </div>
          <div class="row">
            <div :class="['col-6 form-group pr-3', hasErrorFiled('phone')]">
              <input-phone
                v-if="model.country == 'Brasil'"
                id="feTelefone"
                class="form-control"
                :placeholder="`${translate.phone}`"
                :model.sync="model.phone"
                required
                :state="hasErrorFiled('phone')"
                @change="checkPhone()"
              ></input-phone>
              <div v-else class="international-phone">
                <input
                  type="text"
                  class="form-control"
                  v-model="model.phone"
                  :placeholder="`${translate.phone}`"
                />
                <small
                  >Use an international format (for instance:
                  +1-541-000-0000)</small
                >
              </div>
              <div class="invalid-feedback" v-if="errors.phone.required">
                {{ translate.phone }} {{ translate.required }}
              </div>
              <div class="invalid-feedback" v-if="errors.phone.invalid">
                {{ translate.phone }} {{ translate.invalid }}
              </div>

            </div>
            <div :class="['col-6 form-group', hasErrorFiled('zipcode')]">
              <masked-input
                type="text"
                class="text-left form-control"
                id="inputCEP"
                :placeholder="`${translate.zipcode}`"
                :mask="mask"
                :guide="false"
                v-model="model.zipcode"
                @change="changeCep()"
              ></masked-input>
              <div class="invalid-feedback" v-if="errors.zipcode.required">
                {{ translate.zipcode }} {{ translate.required }}
              </div>
              <div class="invalid-feedback" v-if="errors.zipcode.invalid">
                {{ translate.zipcode }} {{ translate.invalid }}
              </div>
            </div>
          </div>
          <div class="row">
            <div :class="['col-6 form-group pr-3', hasErrorFiled('state')]">
              <select v-if="model.country == 'Brasil'" class="form-control" v-model="model.state">
                <option value="" selected>{{ translate.uf }}</option>
                <option value="AC">Acre</option>
                <option value="AL">Alagoas</option>
                <option value="AP">Amapá</option>
                <option value="AM">Amazonas</option>
                <option value="BA">Bahia</option>
                <option value="CE">Ceará</option>
                <option value="DF">Distrito Federal</option>
                <option value="ES">Espírito Santo</option>
                <option value="GO">Goiás</option>
                <option value="MA">Maranhão</option>
                <option value="MT">Mato Grosso</option>
                <option value="MS">Mato Grosso do Sul</option>
                <option value="MG">Minas Gerais</option>
                <option value="PA">Pará</option>
                <option value="PB">Paraíba</option>
                <option value="PR">Paraná</option>
                <option value="PE">Pernambuco</option>
                <option value="PI">Piauí</option>
                <option value="RJ">Rio de Janeiro</option>
                <option value="RN">Rio Grande do Norte</option>
                <option value="RS">Rio Grande do Sul</option>
                <option value="RO">Rondônia</option>
                <option value="RR">Roraima</option>
                <option value="SC">Santa Catarina</option>
                <option value="SP">São Paulo</option>
                <option value="SE">Sergipe</option>
                <option value="TO">Tocantins</option>
              </select>
              <input
                v-else
                type="text"
                class="form-control"
                v-model="model.state"
                :placeholder="`${translate.state}`"
              />
              <div class="invalid-feedback">
                {{ translate.country }} {{ translate.required }}
              </div>
            </div>
            <div :class="['col-6 form-group', hasErrorFiled('city')]">
              <autocomplete
                ref="autocomplete"
                :placeholder="`${translate.city}`"
                :items="cities"
                item-show="city"
                :on-input="onInput"
                :on-select="setCityInModel"
                :on-blur="checkValidadeCity"
              ></autocomplete>
              <div class="invalid-feedback">
                {{ translate.city }} {{ translate.required }}
              </div>
            </div>
          </div>
          <div class="row">
            <div :class="['col-6 form-group pr-3', hasErrorFiled('role')]">
            <select class="form-control" v-model="model.role">
                <option value="" selected>{{ translate.role }}</option>
                <option value="Profissional Especificador">
                  {{ translate.professional }}
                </option>
                <option value="Consumidor Final">{{ translate.consumer }}</option>
                <option value="Outros">{{ translate.others }}</option>
              </select>
            </div>
            <div :class="['col-6 form-group', hasErrorFiled('contact_by')]">
              <select class="form-control" v-model="model.contact_by">
                <option value="" selected>{{ translate.contact_by }}</option>
                <option value="E-mail">{{ translate.email }}</option>
                <option value="Whatsapp">Whatsapp</option>
                <option value="Contato telefônico">{{ translate.call }}</option>
              </select>
              <div class="invalid-feedback">
                {{ translate.contact_by }} {{ translate.required }}
              </div>
            </div>
          </div>
          <div class="m-4">
            <div class="row">
              <div :class="['col-12 form-group checkbox', { checked: model.newsletter }]">
                <label>
                  <input type="checkbox" v-model="model.newsletter" />&nbsp;<span class="item-label">{{ translate.newsletter }}</span>
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div
                  class="g-recaptcha"
                  data-theme="dark"
                  data-sitekey="6Le5b1EoAAAAAH1K4m5-sjLRHA0NLxpkhPKr9lfA"
                ></div>
              </div>
            </div>
            <div class="row" v-if="$route.params.language == 'pt'">
              <div :class="['col-12 form-group checkbox', { checked: model.acceptance }]">
                <label>
                  <input type="checkbox" v-model="model.acceptance" required />&nbsp;
                  <span class="item-label">Li, aceito e autorizo a utilização dos meus dados conforme a
                    <a href="https://derosso.com.br/privacidade" style="text-decoration: underline" >Política de Privacidade</a>
                    e Proteção de Dados da DeRosso Ltda.
                  </span>
                </label>
              </div>
            </div>
          </div>
          <div class="row justify-between">
            <div class="col-3 form-group button">
              <button type="submit" :disabled="loading" class="btn">{{ translate.button }}</button>
            </div>
            <div class="col-12 form-group invalid" v-if="hasErrors == false">
              <div class="invalid-feedback message">{{ translate.error }}</div>
            </div>
            <div class="col-12 form-group invalid" v-if="requestError == true">
              <div class="invalid-feedback message">{{ translate.request_error }}</div>
            </div>
            <div class="col-12 form-group valid" v-if="loading">
              <div class="valid-feedback message">{{ translate.success }}</div>
            </div>
          </div>
        </form>
      </div>
    </main>
    <FooterComponent />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import HeaderComponent from './Header.vue';
import FooterComponent from './Footer.vue';
import MaskedInput from 'vue-text-mask';
import ValidateForm from '../shared/ValidateForm';
import InputPhone from '../shared/InputPhone';
import Events from '../shared/events';
import LeadService from "../service/lead";
import { formEn, formIt, formEs, formPt } from '../lang';
import { lead } from './mockup';
import cities from '../shared/cities';
import Autocomplete from '../shared/Autocomplete.vue';

export default {
  name: "form-register",
  components: {
    HeaderComponent,
    FooterComponent,
    MaskedInput,
    InputPhone,
    Autocomplete,
  },
  mixins: [ValidateForm],
  data() {
    return {
      model: { ...lead },
      translate: { ...formPt },
      errors: {
        email: { required: false },
        name: { required: false },
        role: { required: false },
        phone: { required: false, invalid: false },
        city: { required: false },
        state: { required: false },
        country: { required: false },
        zipcode: { required: false, invalid: false },
        contact_by: { required: false },
      },
      requestError: false,
      loading: false,
    };
  },
  computed: {
    cities() {
      if (this.model.state) {
        const response = cities.filter(item => {
          if (item.uf === this.model.state) {
            if (this.model.city) {
              return item.city.toLowerCase().startsWith(this.model.city.toLowerCase());
            }
            return item;
          }
        });
        return response.slice(0, 20);
      }
      return cities.slice(0, 20);
    },
    mask() {
      if (this.model.country == 'Brasil') {
        return [/\d/, /\d/,'.', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]
      }
      return false;
    },
  },
  methods: {
    ...mapActions([
      'setLead',
    ]),
    checkLanguage() {
      const language = this.$route.params.language;
      if (language == 'pt') {
        this.errors.acceptance = { required: false };
      }
      if (language) {
        switch (language) {
          case 'en':
            return this.setLanguage(formEn, 'United States');
          case 'es':
            return this.setLanguage(formEs, 'Spain');
          case 'it':
            return this.setLanguage(formIt, 'Italy');
          case 'pt':
          default:
            return this.setLanguage(formPt, 'Brasil');
        }
      }
    },
    save() {
      if (this.checkForm()) {
        this.requestError = false;
        this.loading = true;
        this.gtagReport();
        LeadService.getCoordenates(this.model)
        .then(response => {
          if (response.length == 0) {
            return this.errors.zipcode.invalid = true;
          }
          const { location } = response[0].geometry;
          this.model.lat = location.lat ? location.lat.toString() : '';
          this.model.lng = location.lng ? location.lng.toString() : '';
          this.saveLead();
        })
      }
    },
    setCityInAutocompleteInput() {
      this.$refs.autocomplete.$refs.input.value = this.model.city ? this.model.city : '';
    },
    onInput(param) {
      this.model.city = param ? param : this.model.city;
    },
    setCityInModel(param) {
      this.model.city = param.city ? param.city : param;
      this.setCityInAutocompleteInput();
    },
    checkValidadeCity() {
      setTimeout(() => {
        if (this.model.country === 'Brasil') {
          const test = cities.some(item => item.city == this.model.city);
          if (!test) {
            this.model.city = null;
            this.setCityInAutocompleteInput();
          }
        }
      }, 200);
    },
    saveLead() {
      this.model.visited_product = this.$route.query.product;
      LeadService.save(this.model)
        .then(response => {
          this.loading = false;
          this.setLead(response);
          this.$router.push({ name: 'result' });
          setTimeout(() => {
            Events.$emit('success', response);
          }, 20);
        })
        .catch(error => {
          console.log('error', error);
          this.loading = false;
          this.requestError = true;
        });
    },
    changeCep() {
      this.errors.zipcode.invalid = false;
      if (this.model.country == 'Brasil') {
        if (this.model.zipcode.length < 10) {
          this.errors.zipcode.invalid = true;
          return false;
        }
        this.loading = true;
        return this.getAddressByZipcode();
      }
    },
    checkPhone() {
      this.errors.phone.invalid = false;
      if (this.model.country == 'Brasil' && this.model.phone.length < 10) {
        this.errors.phone.invalid = true;
      }
    },
    getAddressByZipcode() {
      LeadService.getAddressByZipcode(this.model.zipcode)
        .then(response => {
          if (response.length == 0) {
            return this.errors.zipcode.invalid = true;
          }
          this.setAddressInModel(response);
        })
        .finally(() => this.loading = false);
    },
    setAddressInModel(address) {
      if (address.erro) {
        this.model.city = null;
        this.model.state = null;
        this.errors.city.required = true;
        this.errors.state.required = true;
        this.setCityInAutocompleteInput();
        return false;
      }
      this.model.city = address.localidade;
      this.model.state = address.uf;
      this.setCityInAutocompleteInput();
    },
    getInformation(address_components, type = 'administrative_area_level_1') {
      const [info] = address_components.filter(addresses => {
        if (addresses.types.indexOf(type) != -1) {
          return addresses;
        }
      });
      return info;
    },
    setLanguage(language, country) {
      this.translate = language;
      this.model.country = country;
    },
    gtagReport() {
      this.$gtag.event('event', 'conversion', {
        'send_to': 'AW-726506946/tBVWCOLLi-UBEMK7ttoC',
      });
    },
  },
  mounted() {
    this.checkLanguage();
    Events.$on('change_translate', () => {
      this.checkLanguage();
    });
  },
};
</script>

<style lang="scss" scoped>
.imprensa-assessoria {
  text-align: left;
}
.row {
  margin: 10px 0 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  &.justify-between {
    justify-content: space-between;
  }
  .international-phone {
    .form-control {
      margin-bottom: 0 !important;
    }
    small {
      font-size: 10px;
      color: #989898;
    }
  }
  .form-group {
    text-align: left;
    .invalid-feedback {
      display: none;
      color: red;
    }
    &.invalid {
      .invalid-feedback {
        display: block;
      }
      .invalid-feedback.message {
        border: 2px solid red !important;
      }
    }
    .valid-feedback {
      display: block;
      border: 2px solid #47e947 !important;
    }
    .message {
      color: #fff;
      text-align: center;
      padding: 10px !important;
    }
    :deep(.form-control) {
      display: block;
      width: 100%;
      outline: none;
      background: #3C3C3C;
      margin-bottom: 10px;
      font-size: 15px;
      font-weight: 300;
      height: 60px;
      color: #fff;
      position: relative;
      z-index: 20;
      padding: 1.1rem;
      border: 0;
      font-family: 'Montserrat', sans-serif;
      &::placeholder {
        color: #fff;
      }
    }
    select.form-control {
      border-right: 10px solid #3C3C3C;
    }
    .btn {
      color: white;
      font-weight: 400;
      letter-spacing: 1.5px;
      font-size: 14px;
      text-decoration: none;
      text-transform: uppercase;
      border: 0;
      transition: all 0.2s ease-in-out;
      &:hover {
        border-color: #707070;
        background-position: -100% 0;
      }
    }
    &.checkbox {
      margin-bottom: 5px;
      label {
        position: relative;
        cursor: pointer;
        padding-left: 30px;
        font-weight: 300;
        min-height: 30px;
        font-size: 14px;
        &:before {
          content: "";
          position: absolute;
          width: 20px;
          height: 20px;
          left: 0;
          border: 2px solid #C52B2B;
          background-color: #fff;
          vertical-align: bottom;
        }
        input[type="checkbox"] {
          position: absolute;
          z-index: -1;
          opacity: 0;
        }
      }
      &.checked {
        label {
          &:before {
            background-color: #C52B2B;
          }
          &:after {
            content: "";
            position: absolute;
            left: 8px;
            top: 1px;
            width: 5px;
            height: 10px;
            border-right: 2px solid #fff;
            border-bottom: 2px solid #fff;
            transform: rotate(45deg);
          }
        }
      }
    }
  }
  .button {
    display: flex;
    padding-right: 0;
    text-align: center;
    font-weight: 400;
    button {
      width: 20rem;
      white-space: nowrap;
      cursor: pointer;
    }
  }
}
.container {
  background:#333333;
  main {
    .wpb_wrapper {
      color: #fff;
      .title {
        position: relative;
        h2 {
          font-weight: normal;
        }
        p {
          margin: 35px 0;
          font-size: 16px;
        }
      }
    }
    .m-4 {
      margin: 20px 0;
    }
    .pr-3 {
      padding-right: 16px;
    }
  }
}
.item-label a {
  color: #fff;
}

@media screen and (max-width: 600px) {
  .container main .wpb_wrapper {
    .row {
      margin-top: 0;
      .form-group {
        width: 100%;
        padding: 0;
      }
    }
    .m-5 .row {
      margin-top: 15px;
    }
  }
}
</style>
